<template>
  <div>
    <ValidationObserver slim v-slot="{ handleSubmit }">
      <v-card elevation="0" style="overflow-y:auto; height: calc(100vh - 200px)">
        <v-card-text>
          <v-container>
            <h1 class="mb-5">PADRES Y/O TUTORES</h1>
            <v-row>
              <v-col cols="12" class="d-flex">
                <label
                  :class="{
                    'text-decoration-underline black--text font-weight-bold':
                      padre_tutor === 3,
                  }"
                  >TUTOR</label
                >
                <v-switch
                  class="my-0 mx-5"
                  v-model.number="padre_tutor"
                  :true-value="1"
                  :false-value="3"
                ></v-switch>
                <label
                  :class="{
                    'text-decoration-underline black--text font-weight-bold':
                      padre_tutor === 1,
                  }"
                  >PADRE</label
                >
              </v-col>
            </v-row>
            <v-row>
             
              <v-col cols="12" md="4">
                
                <validation-provider
                  name="Nombre."
                  :rules="{ required: flag_padre, max: flag_padre? { length:45 } : false }"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    label="Nombre"
                    v-model="padre_nombre"
                    class="my-mayus"
                    :error-messages="errors"
                    maxlength="45"
                    counter="45"
                    filled
                  ></v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="4">
               
                <validation-provider
                  name="Primer Apellido."
                  :rules="{ required:flag_padre?validarMaterno_p?true:false:flag_padre , max: flag_padre ? { length: 45 } : false }"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    label="Primer Apellido"
                    v-model="padre_paterno"
                    class="my-mayus"
                    :error-messages="errors"
                    maxlength="45"
                    counter="45"
                    filled
                  ></v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="4">
                
                <validation-provider
                  name="Segundo Apellido."
                  :rules="{ required:flag_padre?validarPaterno_p?true:false:flag_padre, max: flag_padre ? { length: 45 } : false }"
                  v-slot="{ errors }"
                > 
                  <v-text-field
                    label="Segundo Apellido"
                    v-model="padre_materno"
                    class="my-mayus"
                    :error-messages="errors"
                    maxlength="45"
                    counter="45"
                    filled
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <validation-provider
                  name="Teléfono."
                  :rules="{ required:flag_padre, tel:flag_padre? { length: 14 }: false }"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="padre_telefono"
                    label="Teléfono"
                    class="my-mayus"
                    v-mask="'(###)-###-####'"
                    :error-messages="errors"
                    filled
                  ></v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="4">
                <validation-provider
                  name="Correo."
                  :rules="{ required: flag_padre, email:flag_padre, min: flag_padre? { length:10 }: false, max: flag_padre? { length: 50 } : false }"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="padre_correo"
                    label="Correo"
                    prepend-inner-icon="mdi-at"
                    :error-messages="errors"
                    maxlength="45"
                    counter="45"
                    filled
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <label>¿Has sido miembro de algún colegio jesuita?</label>
                <v-radio-group
                  v-model="padre_jesuita"
                  row
                  class="pt-0 mt-0"
                >
                  <v-radio label="Sí" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="4" v-if="padre_jesuita">
                <validation-provider
                  name="Otra escuela."
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select multiple
                    v-model="padre_colegio"
                    label="Especificar colegio(s) jesuita"
                    :items="lst_colegios"
                    item-text="nombre"
                    item-value="id_escuela_jesuita"
                    :error-messages="errors"
                    filled
                  ></v-select>
                </validation-provider>
              </v-col>
              <v-col
                cols="12"
                md="4" v-if="otra_escuela_padre && padre_jesuita">
                <validation-provider
                  name="Escuela otra."
                  rules="required"
                  v-slot="{ errors }">
                  <v-text-field
                    v-model="padre_colegio_nombre"
                    label="Otra escuela."
                    prepend-inner-icon="mdi-map-marker"
                    class="my-mayus"
                    :error-messages="errors"
                    maxlength="80"
                    counter="80"
                    filled
                    >
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-divider class="mt-5"></v-divider>

            <v-row>
              <v-col cols="12" class="d-flex mt-5">
                <label
                  :class="{
                    'text-decoration-underline black--text font-weight-bold':
                      madre_tutor === 4,
  }"
                  >TUTORA</label
                >
                <v-switch
                  class="my-0 mx-5"
                  v-model.number="madre_tutor"
                  :true-value="2"
                  :false-value="4"
                ></v-switch>
                <label
                  :class="{
                    'text-decoration-underline black--text font-weight-bold':
                      madre_tutor === 2,
                  }"
                  >MADRE</label
                >
              </v-col>
            </v-row>
            <v-row>
             
              <v-col cols="12" md="4">
                <validation-provider
                  name="Nombre"
                  :rules="{ required: flag_madre, max: flag_madre? { length: 45 }: false }"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    label="Nombre"
                    v-model="madre_nombre"
                    class="my-mayus"
                    :error-messages="errors"
                    maxlength="45"
                    counter="45"
                    filled
                  ></v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="4">
                <validation-provider
                  name="Primer Apellido"
                  :rules="{ required:flag_madre?validarMaterno_m?true:false:flag_madre , max: flag_madre ? { length: 45 } : false }"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    label="Primer Apellido"
                    v-model="madre_paterno"
                    class="my-mayus"
                    :error-messages="errors"
                    maxlength="45"
                    counter="45"
                    filled
                  ></v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="4">
                <validation-provider
                  name="Segundo Apellido"
                  :rules="{ required:flag_madre?validarPaterno_m?true:false:flag_madre, max: flag_madre ? { length: 45 } : false }"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    label="Segundo Apellido"
                    v-model="madre_materno"
                    class="my-mayus"
                    :error-messages="errors"
                    maxlength="45"
                    counter="45"
                    filled
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <validation-provider
                  name="Teléfono"
                  :rules="{ required: flag_madre, tel:flag_madre? { length: 14 } : false }"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="madre_telefono"
                    label="Teléfono"
                    class="my-mayus"
                    v-mask="'(###)-###-####'"
                    :error-messages="errors"
                    filled
                  ></v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="4">
                <validation-provider
                  name="Correo"
                  :rules="{ required: flag_madre, email:flag_madre, min: flag_madre? { length:10 }: false, max: flag_madre? { length: 50 } : false }"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="madre_correo"
                    label="Correo"
                    prepend-inner-icon="mdi-at"
                    :error-messages="errors"
                    maxlength="45"
                    counter="45"
                    filled
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <label>¿Has sido miembro de algún colegio jesuita?</label>
                <v-radio-group
                  v-model="madre_jesuita"
                  row
                  class="pt-0 mt-0"
                >
                  <v-radio label="Sí" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="4" v-if="madre_jesuita">
                <validation-provider
                  name="Otra escuela"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select multiple
                    v-model="madre_colegio"
                    label="Especificar colegio(s) jesuita"
                    :items="lst_colegios"
                    item-text="nombre"
                    item-value="id_escuela_jesuita"
                    :error-messages="errors"
                    filled
                  ></v-select>
                </validation-provider>
              </v-col>
              <v-col
                cols="12"
                md="4"
                v-if="otra_escuela_madre">
                <validation-provider
                  name="Otra escuela"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="madre_colegio_nombre"
                    label="Otra escuela"
                    prepend-inner-icon="mdi-map-marker"
                    class="my-mayus"
                    :error-messages="errors"
                    counter
                    filled
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-divider class="mt-5"></v-divider>
          </v-container>
        </v-card-text>
        <v-card-actions class="mobil-botones">
          <v-spacer></v-spacer>
          <v-btn class="mr-3 px-4 white--text" style="background: linear-gradient(0deg, rgba(112,112,112,1) 0%, rgba(156,153,153,1) 100%);" rounded large
          @click="dialogRegresar = true"
          :disabled="loading">
            <v-icon class="mr-2">mdi-arrow-left</v-icon>REGRESAR
          </v-btn>
          <v-btn class="mr-3 white--text px-4" style="background: linear-gradient(0deg, rgba(241,37,53,1) 0%, rgba(255,105,105,1) 100%)" rounded large
          @click="dialogSalir = true"
          :disabled="loading">
            <v-icon class="mr-2">mdi-close-box</v-icon>SALIR
          </v-btn>
          <v-btn
            v-if="save_update"
             style="background: linear-gradient(0deg, rgba(255,182,0,1) 0%, rgba(255,219,130,1) 100%);"
             rounded
             large
            class="black--text px-4"
            @click="handleSubmit( updateDatosFamiliares )"
            :loading="loading"
          >
            <v-icon class="mr-2">mdi-content-save</v-icon>CONTINUAR Y GUARDAR
          </v-btn>

          <v-btn
            v-else
             style="background: linear-gradient(0deg, rgba(255,182,0,1) 0%, rgba(255,219,130,1) 100%);" 
             rounded
             large
            class="black--text px-4"
            @click="handleSubmit( updateDatosFamiliares )"
            :loading="loading"
          >
            <v-icon class="mr-2">mdi-content-save</v-icon>CONTINUAR Y GUARDAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>

    <!-- REGISTRO CREADO -->
    <v-dialog v-model="dialog" width="450" persistent>
      <v-card>
        <v-card-text class="pt-10 pb-0">
          <h3 class="black--text">
            <v-icon>mdi-information</v-icon>
            Registro actualizado con éxito
          </h3>
          <div class="mt-5">
            <p class="text-justify">
              Tu información del <b>paso 2</b> ha sido guardada.
            </p>
            <p class="text-justify">
              Clic en [ACEPTAR] para continuar.
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="bachillerato" dark
              @click="$emit('emit-next',3), dialog = false">
            <v-icon>mdi-check</v-icon>
            ACEPTAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / REGISTRO CREADO -->
    <!-- SALIR -->
    <v-dialog v-model="dialogSalir" width="450" persistent>
      <v-card>
        <v-card-text class="pt-10 pb-0">
          <h3 class="black--text">
            <v-icon>mdi-information</v-icon>
            Salir 
          </h3>
          <div class="mt-5">
            <p class="text-justify">
              ¿Esta seguro de <b>no continuar</b> con la captura?
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="error" dark
              @click="dialogSalir = false">
            <v-icon>mdi-close-box-outline</v-icon>
            NO
          </v-btn>
          <v-btn class="bachillerato" dark
              @click="$emit('emit-salir'), dialogSalir = false">
            <v-icon>mdi-check</v-icon>
            SÍ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / SALIR -->
    <!-- REGRESAR -->
    <v-dialog v-model="dialogRegresar" width="450" persistent>
      <v-card>
        <v-card-text class="pt-10 pb-0">
          <h3 class="black--text">
            <v-icon>mdi-information</v-icon>
            Regresar 
          </h3>
          <div class="mt-5">
            <p class="text-justify">
              ¿Esta seguro de <b>regresar</b> al <b>paso 1</b>?
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="error" dark
              @click="dialogRegresar = false">
            <v-icon>mdi-close-box-outline</v-icon>
            NO
          </v-btn>
          <v-btn class="bachillerato" dark
              @click="$emit( 'emit-last', 1 ), dialogRegresar = false">
            <v-icon>mdi-check</v-icon>
            SÍ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        <v-snackbar
      v-model="snackbar"
    >
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          :color=color_mensaje
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
    <!-- / REGRESAR -->

  </div>
</template>

<script setup>
import { onMounted, ref , computed, watch,getCurrentInstance} from 'vue';
import axios from "axios";
// import { mask } from "vue-the-mask";
import isUndefined from "lodash/isUndefined";
import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString'

const root=getCurrentInstance()?.proxy

    // PADRE - TUTOR
    let padre_id=0;
    const padre_tutor = ref(1); // 1 = Padre, 3 = Tutor
    const padre_nombre = ref("");
    const padre_paterno = ref("");
    const padre_materno = ref("");
    const padre_telefono = ref("");
    const padre_correo = ref("");
    const padre_jesuita = ref(false);
    const padre_colegio = ref([]);
    const padre_colegio_nombre = ref("");

    let madre_id=0;
    const madre_tutor = ref(2);// 2 = Madre, 4 = Tutora
    const madre_nombre = ref("");
    const madre_paterno = ref("");
    const madre_materno = ref("");
    const madre_telefono = ref("");
    const madre_correo = ref("");
    const madre_jesuita = ref(false);
    const madre_colegio = ref([]);
    const madre_colegio_nombre = ref("");

    const lst_colegios=ref([])
    const loading=ref(false)
    const dialog=ref(false)
    const dialogSalir=ref(false)
    const dialogRegresar=ref(false)
    const save_update=ref(true)
    const snackbar=ref(false)
    const text=ref('')
    const color_mensaje=ref('success')

    onMounted(()=>{
      getColegios();
      if(root.$ls.get('paso',0)>0)getDatosfamiliares();
    })

    const flag_padre = computed(
      () => {
        if(isString(padre_nombre.value) && padre_nombre.value != "")return true;
        else if(!(isString(madre_nombre.value) && madre_nombre.value != "")) return true;
        else return false;
        }
    );
    const flag_madre = computed(
      () =>{ 
        if(isString(madre_nombre.value) && madre_nombre.value != "")return true;
        else if(!(isString(padre_nombre.value) && padre_nombre.value != "")) return true;
        else return false;
        }
    );

     const validarPaterno_p = computed(() => padre_paterno.value === "");
     const validarMaterno_p = computed(() => padre_materno.value === "");

     const validarPaterno_m = computed(() => madre_paterno.value === "");
     const validarMaterno_m = computed(() => madre_materno.value === "");

    const otra_escuela_padre=computed(()=>padre_colegio.value.includes(0))
    const otra_escuela_madre=computed(()=>madre_colegio.value.includes(0))

    watch(padre_colegio,(item)=>{
      if(!item.includes(0))padre_colegio_nombre.value=''
    })

    watch(madre_colegio,(item)=>{
      if(!item.includes(0))madre_colegio_nombre.value=''
    })
   watch(padre_jesuita,(item)=>{
      if(!item){
        padre_colegio.value=[]
        padre_colegio_nombre.value=''
      }
    })

    watch(madre_jesuita,(item)=>{
      if(!item){
        madre_colegio.value=[]
        madre_colegio_nombre.value=''
      }
    })
    

    async function getDatosfamiliares(){
      root.$Progress.start()//init cargando...
      let id_precaptura=root.$ls.get('id',0)
      let {data,status}=await axios.get(`precaptura/familiares/${id_precaptura}`)

      if(data.length>0){
        save_update.value=false

        let padre = data.find(i=> parseInt(i.id_tipo_tutor) === 1 || parseInt(i.id_tipo_tutor) === 3);
        let madre = data.find(i=> parseInt(i.id_tipo_tutor) === 2 || parseInt(i.id_tipo_tutor) === 4);

        if(!isUndefined(padre))
        {
          
            padre_id=padre.id_mama_papa
            padre_tutor.value=parseInt(padre.id_tipo_tutor)
            padre_nombre.value=padre.nombre
            padre_paterno.value=padre.primer_apellido
            padre_materno.value=padre.segundo_apellido
            padre_telefono.value=padre.telefono
            padre_correo.value=padre.correo

            // Obtener escuelas
            if ( !isUndefined( padre.escuelas ) && padre.escuelas.length>0 ) { 
              padre_jesuita.value = true
              padre_colegio.value = padre.escuelas.map((i) => parseInt(i));
            }
            // Otra escuela
            if ( !isUndefined(padre.id_escuela_jesuita_otra)) {
              padre_jesuita.value = true
              padre_colegio.value.unshift( 0 );
              padre_colegio_nombre.value = padre.otra
            }
        }

        if(!isUndefined(madre))
        {
            madre_id=madre.id_mama_papa
            madre_tutor.value=parseInt(madre.id_tipo_tutor)
            madre_nombre.value=madre.nombre
            madre_paterno.value=madre.primer_apellido
            madre_materno.value=madre.segundo_apellido
            madre_telefono.value=madre.telefono
            madre_correo.value=madre.correo

            // Obtener escuelas
            if ( !isUndefined( madre.escuelas ) && madre.escuelas.length>0 )  { 
              madre_jesuita.value = true
              madre_colegio.value = madre.escuelas.map((i) => parseInt(i));
            }
           // Otra escuela
            if ( !isUndefined(madre.id_escuela_jesuita_otra)) {
              madre_jesuita.value = true
              madre_colegio.value.unshift( 0 );
              madre_colegio_nombre.value = madre.otra
            }
        }

      }

      root.$Progress.finish()//fin carga
      
    }

    async function saveDatosFamiliares() {

      let informacion = []

      if (flag_padre.value) {
        informacion.push({
          id_mama_papa: padre_id,
          id_tipo_tutor: padre_tutor.value,
          telefono: padre_telefono.value,
          nombre: padre_nombre.value,
          primer_apellido: padre_paterno.value,
          segundo_apellido: padre_materno.value,
          correo: padre_correo.value,
          id_escuela_jesuita: padre_colegio.value.filter(i=>i>0),
          escuela_otra: padre_colegio_nombre.value,
        });
      }

      if (flag_madre.value) {
        informacion.push({
          id_mama_papa: madre_id,
          id_tipo_tutor: madre_tutor.value,
          telefono: madre_telefono.value,
          nombre: madre_nombre.value,
          primer_apellido: madre_paterno.value,
          segundo_apellido: madre_materno.value,
          correo: madre_correo.value,
          id_escuela_jesuita: madre_colegio.value.filter(i=>i>0),
          escuela_otra: madre_colegio_nombre.value,
        });
      }

      if(!isEmpty(informacion)){
        const id_precaptura = root.$ls.get( 'id', 0 )
      
        loading.value = true
        let { data } = await axios.post( 'precaptura/familiares', { informacion, id_precaptura } )
        loading.value = false

        if ( data >0 ) {
          dialog.value = true
        }
      }
 
      
    }

    async function updateDatosFamiliares() {

      let informacion = []
      const id_precaptura = root.$ls.get( 'id', 0 )

      if (flag_padre.value) {
        informacion.push({
          id_mama_papa: padre_id,
          id_tipo_tutor: padre_tutor.value,
          telefono: padre_telefono.value,
          nombre: padre_nombre.value,
          primer_apellido: padre_paterno.value,
          segundo_apellido: padre_materno.value,
          correo: padre_correo.value,
          id_escuela_jesuita: padre_colegio.value.filter(i=>i>0),
          escuela_otra: padre_colegio_nombre.value,
        });
      }else{
        if(padre_id>0 && id_precaptura>0 ){
            let { data } = await axios.delete( `precaptura/familiares/${padre_id}/${id_precaptura}` )
        }
      }

      if (flag_madre.value) {
        informacion.push({
          id_mama_papa: madre_id,
          id_tipo_tutor: madre_tutor.value,
          telefono: madre_telefono.value,
          nombre: madre_nombre.value,
          primer_apellido: madre_paterno.value,
          segundo_apellido: madre_materno.value,
          correo: madre_correo.value,
          id_escuela_jesuita: madre_colegio.value.filter(i=>i>0),
          escuela_otra: madre_colegio_nombre.value,
        });
      }else{
        if(madre_id>0 && id_precaptura>0 ){
          let { data } = await axios.delete( `precaptura/familiares/${madre_id}/${id_precaptura}` )
        }
      }

      if(!isEmpty(informacion)){
        
        
        loading.value = true
        let { data } = await axios.put( `precaptura/familiares/${id_precaptura}`, { informacion } )
        loading.value = false
    
        if ( data > 0 ) {
          dialog.value = true
        }
      }
    }

    async function getColegios() {
      try {
        let { data } = await axios.get("/precaptura/getEscuelas");
        lst_colegios.value = data;
        lst_colegios.value.unshift({id_escuela_jesuita:0,nombre:'Otro',orden: 0})
      } catch (error) {
        console.error(error);
      }
    }

  
</script>

<style scoped>

@media (max-width: 600px) {
.mobil-botones{
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.mobil-botones button{
  width: 100%;
  margin-left: 0!important;
  margin-right: 0!important;
}
}
</style>